// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qks_","rootMobile":"styles_rootMobile__1fo8-"};